import React, { useEffect, useState } from 'react'
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb'
import ProfileCard from '../common/profileCard'
import StudentSidebar from '../common/recruiterSidebar'
import CircleProgress from '../../Instructor/instructor-dashboard/circleProgress'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { all_routes } from '../../router/all_routes'
import apiInstance from '../../../utility/apiInstance'
import { useSelector } from 'react-redux'
import { Application, User } from '../../../core/types/types'
import RecruiterSidebar from '../common/recruiterSidebar'
import RecruiterStatusGate from '../common/recruiterStatusGate'
import { getCurrencySymbol } from '../../../utility/currencyUtils'

const RecruiterDashboard = () => {
    const [selectedItems, setSelectedItems] = useState(Array(4).fill(false));
    const handleItemClick = (index: number) => {
        setSelectedItems((prevSelectedItems) => {
            const updatedSelectedItems = [...prevSelectedItems];
            updatedSelectedItems[index] = !updatedSelectedItems[index];
            return updatedSelectedItems;
        });
    };

    const user = useSelector((state: any) => state.auth.user);

    const [applications, setApplications] = useState<[Application]>();
    const [activeApplications, setActiveApplications] = useState<[Application]>();
    const [approvedApplications, setApprovedApplications] = useState<[Application]>();
    const [students, setStudents] = useState<User[]>([]);
    const [totalApplications, setTotalApplications] = useState<number>(0);
    const [tasks, setTasks] = useState<any[]>([]);

    const updateTaskStatus = async (taskId: string, status: string) => {
        try {
            await apiInstance.patch(`/api/tasks/${taskId}`, { status });
            setTasks((prevTasks) => prevTasks.map(t => t.id === taskId ? { ...t, status } : t));
        } catch (error) {
            console.error("Error updating task status:", error);
        }
    };

    useEffect(() => {
        const fetchApplications = async () => {
            try {
                const response = await apiInstance.get("/api/applications", {
                    params: {
                        "where[student.agent][equals]": user.id,
                    },
                });

                const fetchedApplications = response.data.docs;
                setTotalApplications(response?.data?.totalDocs)
                setApplications(fetchedApplications);
                setActiveApplications(fetchedApplications.filter((item: Application) => item?.status === 'in_review'))
                setApprovedApplications(fetchedApplications.filter((item: Application) => item?.status === 'approved'))

                if (fetchedApplications && fetchedApplications.length > 0) {
                    const applicationIds = fetchedApplications.map((app: any) => app.id).join(',');
                    const taskRes = await apiInstance.get("/api/tasks", {
                        params: {
                            "where[application][in]": applicationIds
                        }
                    });
                    setTasks(taskRes.data.docs || []);
                }
            } catch (error) {
                console.error("Error fetching applications:", error);
            }
        };

        fetchApplications();

        const fetchStudents = async () => {
            try {
                const res = await apiInstance.get(
                    `/api/users?where[and][0][role][equals]=student&where[and][1][agent][equals]=${user.id}`
                );
                setStudents(res.data.docs);
            } catch (err) {
                console.error("Failed to fetch students:", err);
            }
        };

        if (user?.id) fetchStudents();
    }, [user?.id]);


    return (
        <>
            <div className="content">
                <div className="container">
                    {/* profile box */}
                    <ProfileCard />
                    {/* profile box */}
                    <div className="row">
                        {/* sidebar */}
                        <RecruiterSidebar />
                        {/* sidebar */}
                        <div className="col-lg-9">
                            <RecruiterStatusGate>
                                {/* <h5 className="mb-3 fs-18"></h5>
                            <div className="mb-5">
                                <ImageWithBasePath
                                    src="./assets/img/progress.svg"
                                    className="quiz-ans-bg1"
                                    alt="img"
                                />
                            </div> */}
                                <div className="row">
                                    <div className="col-md-6 col-xl-4">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center">
                                                    <span className="icon-box bg-primary-transparent me-2 me-xxl-3 flex-shrink-0">
                                                        <ImageWithBasePath
                                                            src="assets/img/icon/graduation.svg"
                                                            alt=""
                                                        />
                                                    </span>
                                                    <div>
                                                        <span className="d-block">
                                                            Total Applications
                                                        </span>
                                                        <h4 className="fs-24 mt-1">
                                                            {totalApplications}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xl-4">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center">
                                                    <span className="icon-box bg-secondary-transparent me-2 me-xxl-3 flex-shrink-0">
                                                        <ImageWithBasePath
                                                            src="assets/img/icon/book.svg"
                                                            alt=""
                                                        />
                                                    </span>
                                                    <div>
                                                        <span className="d-block">
                                                            Approved Applications
                                                        </span>
                                                        <h4 className="fs-24 mt-1">
                                                            {
                                                                approvedApplications?.length
                                                            }
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 col-xl-4">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="d-flex align-items-center">
                                                    <span className="icon-box bg-success-transparent me-2 me-xxl-3 flex-shrink-0">
                                                        <ImageWithBasePath
                                                            src="assets/img/icon/course-01.svg"
                                                            alt=""
                                                        />
                                                    </span>
                                                    <div>
                                                        <span className="d-block">
                                                            Students
                                                        </span>
                                                        <h4 className="fs-24 mt-1">
                                                            {students?.length}
                                                        </h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card bg-light quiz-ans-card">
                                    <div className="card-body">
                                        <div className="row align-items-center">
                                            <div className="col-md-8">
                                                <div>
                                                    <h6 className="mb-1">
                                                        Complete your profile{" "}
                                                    </h6>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="text-end">
                                                    <Link
                                                        to={
                                                            all_routes.recruiterSettings
                                                        }
                                                        className="btn btn-primary rounded-pill"
                                                    >
                                                        Profile
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card bg-light quiz-ans-card">
                                    <div className="card-body">
                                        <div className="row align-items-center">
                                            <div className="col-md-8">
                                                <div>
                                                    <h6 className="mb-1">
                                                        Manage student profiles and
                                                        applications{" "}
                                                    </h6>
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="text-end">
                                                    <Link
                                                        to={
                                                            all_routes.recruiterStudents
                                                        }
                                                        className="btn btn-primary rounded-pill"
                                                    >
                                                        Add Student
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <h5 className="mb-3 fs-18">Recent Applications</h5>
                                <div>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className="card">
                                                <div className="card-body">
                                                    {applications &&
                                                        applications?.length > 0 &&
                                                        applications
                                                            .slice(0, 5)
                                                            ?.map((item) => (
                                                                <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-3">
                                                                    <div>
                                                                        <h6
                                                                            className="mb-1"
                                                                            style={{
                                                                                maxWidth:
                                                                                    "800px",
                                                                                overflow:
                                                                                    "hidden",
                                                                                textOverflow:
                                                                                    "ellipsis",
                                                                                whiteSpace:
                                                                                    "nowrap",
                                                                            }}
                                                                            title={
                                                                                item
                                                                                    ?.program
                                                                                    ?.programName
                                                                            }
                                                                        >
                                                                            {
                                                                                item
                                                                                    ?.program
                                                                                    ?.programName
                                                                            }
                                                                        </h6>
                                                                        <div className="d-flex align-items-center">
                                                                            <span className="badge badge-sm bg-light border d-inline-flex me-3">
                                                                                <span
                                                                                    className={
                                                                                        item?.status ===
                                                                                            "pending"
                                                                                            ? "text-warning fw-bold"
                                                                                            : item?.status ===
                                                                                                "in_review"
                                                                                                ? "text-info fw-bold"
                                                                                                : item?.status ===
                                                                                                    "approved"
                                                                                                    ? "text-success fw-bold"
                                                                                                    : item?.status ===
                                                                                                        "declined"
                                                                                                        ? "text-danger fw-bold"
                                                                                                        : ""
                                                                                    }
                                                                                >
                                                                                    {item?.status ||
                                                                                        "pending"}
                                                                                </span>
                                                                            </span>
                                                                            <p className="small">
                                                                                Application
                                                                                Fee
                                                                                :{" "}
                                                                                <span className="heading-color fw-semibold">
                                                                                    {item?.applicationFee
                                                                                        ? `${getCurrencySymbol(item?.institution?.country)}${item.applicationFee}`
                                                                                        : "Free"}
                                                                                </span>
                                                                                <br></br>
                                                                                Student
                                                                                :{" "}
                                                                                <span className="heading-color fw-semibold">
                                                                                    {item
                                                                                        ?.student
                                                                                        ?.email ||
                                                                                        ""}
                                                                                </span>
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex align-items-center">
                                                                        {item?.createdAt
                                                                            ? new Date(
                                                                                item.createdAt
                                                                            ).toLocaleDateString()
                                                                            : ""}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {tasks && tasks.length > 0 && (
                                    <>
                                        <h5 className="mb-3 fs-18 mt-4">Pending Tasks</h5>
                                        <div>
                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <div className="card">
                                                        <div className="card-body">
                                                            <ul className="list-group list-group-flush">
                                                                {tasks.map((task: any) => (
                                                                    <li key={task.id} className="list-group-item px-0 border-bottom-0 mb-3">
                                                                        <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-2">
                                                                            <div>
                                                                                <h6 className="mb-1 text-dark">{task.title}</h6>
                                                                                <p className="mb-0 text-muted small">
                                                                                    Application ID: <span className="fw-semibold text-primary cursor-pointer">#{typeof task.application === 'object' ? task.application.id?.slice(-5) : task.application?.toString().slice(-5)}</span>
                                                                                </p>
                                                                            </div>
                                                                            <div className="d-flex align-items-center">
                                                                                <span className={`badge rounded-pill ${task.status === 'completed' ? 'bg-success' : (task.status === 'in_progress' || task.status === 'in_review') ? 'bg-info' : 'bg-warning'}`}>
                                                                                    {task.status ? task.status.replace('_', ' ').toUpperCase() : 'PENDING'}
                                                                                </span>
                                                                                {task.status !== 'in_review' && task.status !== 'completed' && (
                                                                                    <button 
                                                                                        className="btn btn-sm btn-outline-info ms-2 py-0 px-2" 
                                                                                        style={{ fontSize: '0.75rem' }}
                                                                                        onClick={() => updateTaskStatus(task.id, 'in_review')}
                                                                                    >
                                                                                        Mark In Review
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        {task.description && <p className="mb-0 text-muted small mt-1">{task.description}</p>}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}

                            </RecruiterStatusGate>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RecruiterDashboard